import { splitParentSummary } from './splitParentSummary.js'
import { championFace, championLine } from '../championFace.js'
import { daysToEvent } from '../../../lib/championships.js'
import { championOfRecord, isMultiSchool, schoolApplies } from '../../../lib/championDisplay.js'

const text = value => String(value ?? '').trim()
const sourceUrl = value => {
  try { const url = new URL(text(value)); return ['https:', 'http:'].includes(url.protocol) && !url.username && !url.password ? url.href : '' } catch { return '' }
}

/** Read-only work classification. No winner inferred from a date or pursuit status.
 * A source link is provenance to inspect, not independent verification. */
export function worklistNextWork(record, now = new Date()) {
  const c = record || {}
  if (c.isIndyGroup) return {kind:'group', champion:'Individual winner records', evidence:'Synthetic grouping only. Review the actual member records and their evidence; this grouping cannot be crowned.', next:'Review actual individual records', action:'Review individual records', source:''}
  const split = splitParentSummary(c)
  if (split) return { kind: 'split', champion: split.headline,
    evidence: [split.note, ...split.reasons].join(' '),
    next: 'Review split results', action: 'Review split results', source: '' }
  const named = championOfRecord(c)
  const face = championFace(c)
  const actualAthletes = face.athletes?.filter(athlete => text(athlete.athlete)) || []
  const champion = named ? face.type === 'individual' && !actualAthletes.length ? `${schoolApplies(c) || text(c.winningSchool) === named ? 'Recorded school winner' : 'Recorded winner'}: ${named}` : championLine({...face, athletes: actualAthletes}) : ''
  const source = sourceUrl(c.championSourceUrl ?? c.champion_source_url)
  if (champion) return { kind: source ? 'sourced' : 'unsourced', champion,
    displayedClaims:face.type === 'individual' ? actualAthletes.length ? actualAthletes.flatMap(athlete => [athlete.athlete,athlete.school]).filter(Boolean) : [named] : [face.team || named],
    evidence: source ? 'Sourced on record. Please verify the cited result before use.' : 'Unsourced winner claim. Verification needed before use.',
    next: source ? 'Review champion and prepare follow-up' : 'Research needed. Verify recorded winner',
    action: 'Review winner evidence', source }
  if (isMultiSchool(c)) return { kind: 'multi', champion: 'Multiple schools. No single winner recorded',
    evidence: 'Review each recorded school and its evidence; do not infer one champion.',
    next: 'Review winner records', action: 'Review winner records', source: '' }
  const days = daysToEvent(c, now)
  if (!Number.isFinite(days)) return { kind: 'undated', champion: 'No verified champion recorded',
    evidence: 'Event date unknown or invalid; timing cannot be established.',
    next: 'Confirm event date before research or preparation', action: 'Review event date', source: '' }
  if (days < 0) return { kind: 'research', champion: 'No verified champion recorded',
    evidence: 'Past scheduled date is not proof the event occurred. Verify the result and its source.',
    next: 'Research needed. Verify event and winner', action: 'Review research needs', source: '' }
  return { kind: 'preparation', champion: 'No verified champion recorded',
    evidence: days === 0 ? 'Scheduled for today; no winner is assumed.' : 'Upcoming scheduled event; no winner is assumed.',
    next: 'Preparation work. Confirm schedule, prospects, contacts and artwork', action: 'Review preparation needs', source: '' }
}
